import React from 'react';
import styled from 'styled-components';
import { Button, Tooltip } from 'antd';
import { CodeOutlined, CopyOutlined } from '@ant-design/icons';

import EventsQueryExposureModal from '../../containers/event/QueryExposureModal';

const StyledButton = styled(Button)`
  border: none;
`;

const AdditionalEventOptions = ({ onDuplicateEvent, id }) => {
  const renderButton = (onClick) => (
    <Tooltip placement="top" title="Expose a query">
      <StyledButton
        icon={<CodeOutlined />}
        onClick={(e) => {
          onClick();
          e.target.blur();
        }}
      />
    </Tooltip>
  );

  return (
    <>
      <EventsQueryExposureModal id={id} button={renderButton} />
      <Tooltip placement="top" title="Duplicate">
        <StyledButton icon={<CopyOutlined />} onClick={onDuplicateEvent} />
      </Tooltip>
    </>
  );
};

export default AdditionalEventOptions;
